/**
 * VType, который учитывает разделитель дробной и целой части, заданный в локали бизнес-шаблона.
 * Если бизнес-шаблон не существует, используем точку
 */
Ext.form.VTypes['decimalNumberMask'] = /[0-9.,]/;
Ext.form.VTypes['decimalNumberText'] = 'Invalid decimal number format';
Ext.form.VTypes['decimalNumber'] = function(v) {
    var decimalSeparator = '.';
    if (window.MXBT != null && MXBT.get && MXBT.get('decimalSeparator')) {
        decimalSeparator = MXBT.get('decimalSeparator');
    }

    var pattern = new RegExp('^[0-9]+[' + decimalSeparator + ']{0,1}[0-9]+$');
    var numberPattern = new RegExp('^[0-9]+$');
    return pattern.test(v) || numberPattern.test(v);
};
